export default "/images/money.svg?c078ee5115b98c69f007429579895d12";